import { useState } from "react";
import { Link } from "react-router-dom";
import { home } from "../content/home";
import { useContent, SlotImg, Rich } from "../ui/helpers";

export function RoleViews() {
  const c = useContent(home).views;
  const [open, setOpen] = useState(0);

  return (
    <section className="band-light views" id="views">
      <div className="k-wrap">
        <div className="views-head rv">
          <div><p className="k-label">{c.eyebrow}</p><h2 className="h-sec" style={{ marginTop: 16 }}>{c.title}</h2></div>
          <p>{c.intro}</p>
        </div>
        <div className="panels">
          {c.roles.map((r, i) => (
            <button key={r.tag} type="button" className={`panel${open === i ? " open" : ""}`}
              onMouseEnter={() => setOpen(i)} onFocus={() => setOpen(i)} onClick={() => setOpen(i)} aria-expanded={open === i}>
              <SlotImg slot={r.media} sizes="(min-width: 860px) 50vw, 100vw" />
              <div className="panel-body">
                <p className="k-label">{r.tag}</p>
                <h3>{r.title}</h3>
                <div className="panel-more"><div>
                  <p><Rich text={r.body} /></p>
                  <ul>{r.chips.map((x) => <li key={x}>{x}</li>)}</ul>
                </div></div>
              </div>
            </button>
          ))}
        </div>
        <div className="views-foot">
          <small>{c.note}</small>
          <Link className="tlink" to="/demo#platform-demo">{c.link} →</Link>
        </div>
      </div>
    </section>
  );
}
